import { QueryClient } from "@tanstack/react-query";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";

export const queryClient = new QueryClient({
    defaultOptions: {
        // refetchOnWindowFocus stays OFF, deliberately. Turning it on arrived bundled with the
        // deactivated-guard cache fix, which needed neither it nor anything like it: that fix works
        // by shortening the guard lookup's tier and keeping the list out of localStorage, both of
        // which are scoped to the queries that had the bug. Switching it on globally would make
        // every stale query in the console refetch whenever a backgrounded tab regains focus —
        // a whole-app behaviour change, on a console people leave open all day beside a live map.
        // If it is ever wanted, it should be its own decision with its own reasoning, not a rider.
        queries: { retry: 1, staleTime: 30_000, refetchOnWindowFocus: false },
        mutations: { retry: 0 },
    }
});

export const persister = createSyncStoragePersister({
    storage: window.localStorage,
});

export async function clearCache(): Promise<void> {
    await persister.removeClient();
    queryClient.clear();
}
